import React from "react"
import "./styles.css"
import { RenderIf } from "../../helpers/RenderIf"
import ReactDOM from "react-dom"

export const Loading = ({ showLoading, size = "100px", ...props}) => {

	const SpinnerContainer = ({children, ...props}) => {
		if(props.inFront){
			const portalContainer = document.getElementById("app_root");
			return (
				ReactDOM.createPortal(
					<React.Fragment>
						<div className={`spinner-portal${props.overlay ? " overlay": " non_overlay"}`} >
							{children}
						</div>
					</React.Fragment >, portalContainer)
			)
		}else{
			return(
				<div className={props.className}>
					{children}
				</div>
			)
		}
	}

	return (
		<RenderIf condition={showLoading} >
			<SpinnerContainer {...props}>
				<img src="https://static.sibilus.eu/gfx/loading-icon-0.svg" alt="loading-icon" style={{width: size, height: size}} className={`spinner${props.spinnerClassName ? " " +props.spinnerClassName : ""}`} />
			</SpinnerContainer>
		</RenderIf>
	);
}
